var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("p", [
        _c("label", { attrs: { for: _vm.id } }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.checked,
                expression: "checked"
              }
            ],
            attrs: { type: "checkbox", id: _vm.id },
            domProps: {
              value: _vm.checkedState,
              checked: Array.isArray(_vm.checked)
                ? _vm._i(_vm.checked, _vm.checkedState) > -1
                : _vm.checked
            },
            on: {
              change: [
                function($event) {
                  var $$a = _vm.checked,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = _vm.checkedState,
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.checked = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.checked = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.checked = $$c
                  }
                },
                _vm.visibility
              ]
            }
          }),
          _vm._v(" "),
          _c("span", [
            _vm._v(_vm._s(_vm.showContent ? _vm.hideText : _vm.text))
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.showContent ? _vm._t("default") : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-16ab6264", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16ab6264","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/element/ExpandableContentCheckbox.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-16ab6264","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/element/ExpandableContentCheckbox.vue
// module chunks = 0